export const usd = (n: number) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n);

export const pct = (n: number, d = 1) => `${n.toFixed(d)}%`;

export const scoreTone = (score: number, invert = false) => {
  const s = invert ? 100 - score : score;
  if (s >= 75) return "text-success";
  if (s >= 50) return "text-foreground";
  if (s >= 30) return "text-warning-foreground";
  return "text-danger";
};

export const scoreBg = (score: number, invert = false) => {
  const s = invert ? 100 - score : score;
  if (s >= 75) return "bg-success";
  if (s >= 50) return "bg-accent";
  if (s >= 30) return "bg-warning";
  return "bg-danger";
};
